import { RetryAction, Callout, TechnicalDetails } from '@beyond-js/ui/react';
import { usePresence } from '@accounts/session';
import { Refusal } from '@accounts/transport';

/**
 * A read Accounts refused, with **Try again**, which reads it once at the person's request.
 *
 * A refusal is an answer, so it keeps the danger tone and its "Technical details" (D43): the request's
 * identifier when there was an answer, and the time. It is never read again by itself. A read Accounts
 * did not answer is never this: it is the page's one `Outage`, said once (D163), and the region says it
 * in its own place.
 */
export function Retry({ title, label, busy, onRetry, error }: { title: string; label: string; busy: string; onRetry: () => Promise<boolean>; error?: unknown }) {
	const { language } = usePresence();
	const details = Refusal.is(error) ? { text: `${error.code}: ${error.message}`, request: error.request ?? null, time: error.at, locale: language, labels: TechnicalDetails.labels?.[language] } : null;
	// The shared action is busy while its read runs, and cannot be started twice
	return (
		<Callout tone="danger" live title={title} details={details} actions={<RetryAction labels={{ busy, retry: label }} onClick={() => onRetry()} />} />
	);
}
